import { MODEL_KEY } from '../../../../modules/model/constants'
import { REDUX_LOCAL_KEY } from '../../../redux/constants/local-key'

const WORKOUT_KEY = {
  ...MODEL_KEY,

  NAME: 'name',
  NOTES: 'notes',
  INSTRUCTIONS: 'instructions',

  DURATION: 'duration',
  LEVEL: 'level',
  TYPES: 'types',
  EQUIPMENT: 'equipment',
  MUSCLES: 'muscles',
  SECONDARY_MUSCLES: 'secondaryMuscles',
  DIFFICULTY: 'difficulty',
  IMAGE: 'image',

  COMPLETION_TIME: 'completionTime',

  FEATURED_AT: 'featuredAt',
  RECOMMENDED_AT: 'recommendedAt',
  LOGGED_AT: 'loggedAt',
  STARTED_AT: 'startedAt',
  PLANNED_AT: 'plannedAt',
  SUGGESTED_AT: 'suggestedAt',

  ESTIMATED_METABOLIC_EQUIVALENT: 'estimatedMetabolicEquivalent',
  ESTIMATED_CALORIES: 'estimatedCalories',
  METABOLIC_EQUIVALENT: 'metabolicEquivalent',
  CALORIES: 'calories',
  ESTIMATED_TRAINING_VOLUME: 'estimatedTrainingVolume',
  TRAINING_VOLUME: 'trainingVolume',
  RATING: 'rating',
  SHARE_KEY: 'shareKey',

  // Foreign keys
  AUTHOR_ID: 'authorId',
  PROFILE_ID: 'profileId',
  PLAN_ID: 'planId',
  PARENT_ID: 'parentId',
  ORIGINAL_PARENT_ID: 'originalParentId',

  // Associations
  PARENT: 'parent',
  RECOMMENDED: 'recommended',
  EXERCISE_LOGS: 'exerciseLogs',
  WORKOUT_SECTIONS: 'workoutSections',

  // Local -- not understood by the server
  LOCAL_HAS_ASSOCIATION_CHANGE: REDUX_LOCAL_KEY.HAS_ASSOCIATION_CHANGE,
  LOCAL_IS_DOWNLOADED: REDUX_LOCAL_KEY.IS_DOWNLOADED,
  LOCAL_IS_SUGGESTED: REDUX_LOCAL_KEY.IS_SUGGESTED,
  LOCAL_IS_REORDERING_WORKOUT_SECTIONS: '__localIsReorderingWorkoutSections',
  LOCAL_IS_REORDERING_WORKOUT_EXERCISES: '__localIsReorderingWorkoutExercises',
  LOCAL_IS_REORDERING_WORKOUT_EXERCISE_SETS: '__localIsReorderingWorkoutExerciseSets',
  LOCAL_ACTIVITY: '__localActivity',
  LOCAL_HAS_SUGGESTED_TO_COPY_FROM_WORKOUT_LOCAL: '__localHasSuggestedToCopyFromWorkoutLocal'

}

const WORKOUT_SHALLOW_KEYS = [
  WORKOUT_KEY.NAME,
  WORKOUT_KEY.LEVEL,
  WORKOUT_KEY.DURATION,
  WORKOUT_KEY.MEDIA_RESIZE_MODE,
  WORKOUT_KEY.COMPLETION_TIME
]

export {
  WORKOUT_SHALLOW_KEYS,
  WORKOUT_KEY
}
